import { AllocatedPlaceInput } from '../../lib/types/models/trip-booking/trip-date-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type UpdateTripBookingAllocationsInput = {
  id: number
  data: AllocatedPlaceInput[]
}

export function updateTripBookingAllocations(
  data: UpdateInput<UpdateTripBookingAllocationsInput>
) {
  const { id, ...rest } = data

  return restApiClient
    .url(constructApiUrl(API['trip-bookings'].updateTripBookingAllocations.url, { id }))
    .patch(rest.data)
}
